import { render } from "./Item.vue?vue&type=template&id=2f0230fa&scoped=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=2f0230fa&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2f0230fa"

export default script